import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { QuickReplyState } from '../../types'

export const createQuickReplyAction = createAsyncAction(
  '@chat/CREATE_QUICK_REPLY_REQUEST',
  '@chat/CREATE_QUICK_REPLY_SUCCESS',
  '@chat/CREATE_QUICK_REPLY_FAILURE'
)<Request, Success, Failure>()

const request = (
  state: QuickReplyState,
  action: ActionType<typeof createQuickReplyAction.request>
): QuickReplyState => ({
  ...state,
  isLoadingCreateQuickReply: true
})

const success = (
  state: QuickReplyState,
  action: ActionType<typeof createQuickReplyAction.success>
): QuickReplyState => {
  return {
    ...state,
    isLoadingCreateQuickReply: false,
    isSuccessOnCreateQuickReply: true
  }
}

const failure = (
  state: QuickReplyState,
  action: ActionType<typeof createQuickReplyAction.failure>
): QuickReplyState => ({
  ...state,
  isLoadingCreateQuickReply: false,
  isErrorOnCreateQuickReply: true
})

export const createQuickReplyHandle = { asyncAction: createQuickReplyAction, request, success, failure }
